import { z } from 'zod';

export const loginSchema = z.object({
  email: z.string().email('Email non valida'),
  password: z.string().min(8, 'Password: minimo 8 caratteri'),
  rememberMe: z.boolean().optional(),
});

export const registerSchema = z
  .object({
    email: z.string().email('Email non valida'),
    password: z
      .string()
      .min(8, 'Password: minimo 8 caratteri')
      .regex(/[A-Z]/, 'Richiede almeno una maiuscola')
      .regex(/[0-9]/, 'Richiede almeno un numero'),
    passwordConfirm: z.string(),
    nickname: z.string().min(2, 'Nickname: minimo 2 caratteri').max(50),
    tenantId: z.number().int().positive(),
    gdprConsent: z.literal(true, {
      errorMap: () => ({ message: 'Accettazione GDPR obbligatoria' }),
    }),
  })
  .refine((data) => data.password === data.passwordConfirm, {
    message: 'Le password non coincidono',
    path: ['passwordConfirm'],
  });

export type LoginInput = z.infer<typeof loginSchema>;
export type RegisterInput = z.infer<typeof registerSchema>;
